import script from "./AppModalConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppModalConfirm.vue?vue&type=script&setup=true&lang=js"

import "./AppModalConfirm.vue?vue&type=style&index=0&id=572ffdc8&lang=scss"

const __exports__ = script;

export default __exports__